import { WorkOrderCalendarDateType } from './WorkOrders.enum';

export const workOrderCalendarDateTypeLabels = {
  [WorkOrderCalendarDateType.Entry]: 'Data de entrada',
  [WorkOrderCalendarDateType.Authorization]: 'Data de autorização',
  [WorkOrderCalendarDateType.Close]: 'Data de fechamento',
  [WorkOrderCalendarDateType.Estimated]: 'Data de saída prevista',
  [WorkOrderCalendarDateType.Return]: 'Data de entrega',
};
